import _ from "lodash";
import React from "react";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import ACLStore from "lib/aclStore";
import classes from "./SubjectGroupSelect.scss";

import { FormSelectDropdown } from "UIComponents/SelectDropdown";
import I18nHOC from "UIComponents/I18nHOC";
import Listview from "UIComponents/Listview";
import update from "immutability-helper";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import SubjectEditModal from "./SubjectEditModal";
import { MYP_INTERDISCIPLINARY } from "Constants/stringConstants";
import { Alert, Button, Modal, Tag } from "@toddle-edu/ds-web";
import {
  AddCircleFilled,
  IndividualsSocietiesDuotone,
  ArtDuotone,
  PhysicalHealthEducationDuotone,
  LanguageAcquisitionDuotone,
  LanguageLiteratureDuotone,
  MathematicsDuotone,
  DesignDuotone,
  SciencesDuotone,
  DeleteOutlined,
} from "@toddle-edu/ds-icons";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION } from "Constants/permissionConstants";

const iconSize = "x-small";

const ICON_SUBJECT_GROUP_MAPPING = [
  {
    iconKey: "ARTS",
    icon: <ArtDuotone size={iconSize} color="violet" />,
  },
  {
    iconKey: "L&L",
    icon: <LanguageLiteratureDuotone size={iconSize} color="yellow" />,
  },
  {
    iconKey: "LA",
    icon: <LanguageAcquisitionDuotone size={iconSize} color="yellow" />,
  },
  {
    iconKey: "DESIGN",
    icon: <DesignDuotone size={iconSize} color="pink" />,
  },
  {
    iconKey: "SCI",
    icon: <SciencesDuotone size={iconSize} color="blue" />,
  },
  {
    iconKey: "MATH",
    icon: <MathematicsDuotone size={iconSize} color="violet" />,
  },
  {
    iconKey: "PHE",
    icon: <PhysicalHealthEducationDuotone size={iconSize} color="blue" />,
  },
  {
    iconKey: "I&S",
    icon: <IndividualsSocietiesDuotone size={iconSize} color="pink" />,
  },
  {
    iconKey: "COMMON",
    icon: <IndividualsSocietiesDuotone size={iconSize} color="pink" />,
  },
];

const styles = {
  optionContainerStyle: {
    display: "flex",
    alignItems: "center",
  },
};

export class SubjectGroupSelect extends UIBaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showEditModal: false,
      showObjectiveRemoveModal: false,
      objectiveUpdateValue: {},
      removedObjectiveLevel: {},
    };
    this.pairRefs = {};
  }

  componentDidMount = () => {
    this.createSubjectGroupPairFromValue();
  };

  componentDidUpdate = prevProps => {
    if (
      JSON.stringify(prevProps.value) !== JSON.stringify(this.props.value) ||
      prevProps.multi !== this.props.multi
    ) {
      this.createSubjectGroupPairFromValue();
    }
  };

  isValid = () => {
    const {
      isSubjectEditModal,
      isObjectivePhasesEnabled,
      isObjectivePhaseRecommendationEnabled,
    } = this.props;
    let totalErrors = 0;
    _.map(this.pairRefs, pair => {
      totalErrors += pair.subjectGroup.isValid();
      totalErrors += pair.subject.isValid();
      if (
        (isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled) &&
        pair.objectiveLevelId &&
        !pair.objectiveLevelId.props.disabled
      )
        totalErrors += pair.objectiveLevelId.isValid();
    });
    if (isSubjectEditModal) {
      return totalErrors;
    } else {
      return totalErrors > 0 ? 1 : 0;
    }
  };
  //get selected objective id for the given subject
  getSelectedObjectiveId = ({ subjectId }) => {
    const { options } = this.props;
    const objectiveLevelNodes = _.get(options, "objectiveLevelNodes", []);
    let selectedObjectiveLevels = _.get(options, "selectedObjectiveLevels", []);

    //filter out the empty objectives
    selectedObjectiveLevels = _.filter(selectedObjectiveLevels, Boolean);

    //fetch the objective with subject from selected objective levels
    const objectiveLevelId = [];
    _.forEach(selectedObjectiveLevels, objectiveId => {
      const objective = _.find(objectiveLevelNodes, { id: objectiveId });
      if (
        _.find(_.get(objective, "associatedParents", []), {
          id: subjectId,
        })
      ) {
        objectiveLevelId.push(objectiveId);
      }
    });

    return objectiveLevelId;
  };

  createSubjectGroupPairFromValue = () => {
    const {
      options,
      value,
      multi,
      isObjectivePhasesEnabled,
      isObjectivePhaseRecommendationEnabled,
    } = this.props;
    const initSubject = _.get(options, "initSubject", {});

    const subjectGroupPair = _.map(value, val => {
      const subjectGroups = _.get(options, "subjectGroups", []);

      const subjectGroup = _.find(subjectGroups, subjectGroup => {
        const subjects = _.get(subjectGroup, "subjects", []);
        return _.findIndex(subjects, subject => subject.id == val) >= 0;
      });
      const subjectGroupId = _.get(subjectGroup, "id", null);
      const recommendedObjectiveLevel = ACLStore.can(
        ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION
      )
        ? this.getObjectiveLevelOptions({
            objectiveLevelNodes: _.get(options, "objectiveLevelNodes", []),
            subject: val,
            SubjectGroupList: options?.subjectGroups,
            courseDetails: options?.courseDetails,
            subjectGroup: subjectGroupId,
          })[0]?.recommended
        : "";
      const objectiveLevelId =
        _.size(this.getSelectedObjectiveId({ subjectId: val })) > 0
          ? this.getSelectedObjectiveId({ subjectId: val })
          : recommendedObjectiveLevel;

      return {
        subjectGroup: subjectGroupId,
        subject: val,
        ...(isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled
          ? { objectiveLevelId }
          : {}),
      };
    });

    if (
      (subjectGroupPair.length === 1 && multi) ||
      subjectGroupPair.length === 0
    ) {
      subjectGroupPair.push({
        subjectGroup: "",
        subject: "",
        ...(isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled
          ? { objectiveLevelId: "" }
          : {}),
      });
    }

    const subjectGroupPairList = this.getSubjectList({
      initSubject,
      subjectGroupPair,
    });
    this.setState({ subjectGroupPair: subjectGroupPairList });
  };

  // genrates final pair list in which 1st subject will be initSubject
  getSubjectList = ({ initSubject, subjectGroupPair }) => {
    const initSubjectId = _.get(initSubject, "id", null);
    const firstSubject = _.find(
      subjectGroupPair,
      { subject: initSubjectId },
      null
    );
    const restSubject = _.filter(
      subjectGroupPair,
      pair => pair.subject !== initSubjectId
    );
    if (firstSubject) {
      return [firstSubject, ...restSubject];
    } else {
      //this is added to handle the import of unit from the course where current course subject is not selected
      return [...restSubject];
    }
  };

  onAddClick = () => {
    const {
      subjectGroupPair,
      isObjectivePhasesEnabled,
      isObjectivePhaseRecommendationEnabled,
    } = this.state;
    this.setState({
      subjectGroupPair: [
        ...subjectGroupPair,
        {
          subjectGroup: "",
          subject: "",
          ...(isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled
            ? { objectiveLevelId: "" }
            : {}),
        },
      ],
    });
  };

  onEditClick = () => {
    this.setState({ showEditModal: true });
  };

  onCancelModalEdit = () => {
    this.setState({ showEditModal: false });
  };

  onSaveModalEdit = ({ subjectGroupPair }) => {
    this.setState({ subjectGroupPair }, this.updateValueLocally);
  };

  onDeleteClick = ({ index }) => {
    const { subjectGroupPair } = this.state;
    this.pairRefs = update(this.pairRefs, { $unset: [index] });
    this.setState({
      subjectGroupPair: update(subjectGroupPair, { $splice: [[index, 1]] }),
    });

    setTimeout(() => {
      this.updateValueLocally();
    });
  };

  updateObjectiveOption = ({ index, key, value }) => {
    const { parentType, isSubjectEditModal } = this.props;
    if (
      ACLStore.can(ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION) &&
      (parentType == "UNIT_PLAN" || isSubjectEditModal)
    ) {
      const { subjectGroupPair } = this.state;
      const selectedObjective = subjectGroupPair[index].objectiveLevelId || [];
      const removedObjective = _.difference(selectedObjective, value);

      const { options } = this.props;
      const objectiveLevelNodes = _.get(options, "objectiveLevelNodes", []);

      if (removedObjective.length > 0) {
        const removedObjectiveLevel = _.find(objectiveLevelNodes, {
          id: removedObjective[0],
        });
        this.setState({
          showObjectiveRemoveModal: true,
          objectiveUpdateValue: { index, key, value },
          removedObjectiveLevel,
        });
      } else {
        this.updateOption({
          key: "objectiveLevelId",
          value,
          index,
        });
      }
    } else {
      this.updateOption({
        key: "objectiveLevelId",
        value,
        index,
      });
    }
  };

  updateOption = ({ index, key, value }) => {
    const {
      options,
      isObjectivePhasesEnabled,
      isObjectivePhaseRecommendationEnabled,
    } = this.props;
    const objectiveLevelNodes = _.get(options, "objectiveLevelNodes", []);
    const selectedObjectiveLevelsWithValue = _.get(
      options,
      "selectedObjectiveLevelsWithValue",
      []
    );
    const { subjectGroupPair } = this.state;
    const oldParams = subjectGroupPair[index];
    const newParams = { [key]: value };
    const oldValue = subjectGroupPair[index][key];
    if (key == "subjectGroup" && oldValue != value) {
      newParams["subject"] = "";
      if (isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled) {
        newParams["objectiveLevelId"] = [];
      }
    }
    if (key == "subject" && oldValue != value) {
      //condition to handle if objective for this particular subject is already selected
      //if objective is already selected for this subject in past and user mistakenly
      //removed that subject and if user add that subject again than objective for it will be pre-selected
      //pre-selecteed objectives are the one which was selected before deleting it
      const objectiveLevels = this.getObjectiveLevelOptions({
        objectiveLevelNodes,
        subject: newParams["subject"],
        SubjectGroupList: options?.subjectGroups,
        courseDetails: options?.courseDetails,
        subjectGroup: subjectGroupPair[index].subjectGroup,
      });
      const objectiveLevelOptions = _.map(
        objectiveLevels,
        objectivelevel => objectivelevel.value
      );
      const selectedObjectiveLevelIds = _.intersection(
        selectedObjectiveLevelsWithValue,
        objectiveLevelOptions
      );
      if (isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled) {
        if (_.size(selectedObjectiveLevelIds) == 1) {
          newParams["objectiveLevelId"] = selectedObjectiveLevelIds[0];
        } else if (
          objectiveLevels[0]?.recommended &&
          isObjectivePhaseRecommendationEnabled
        ) {
          newParams["objectiveLevelId"] = objectiveLevels[0].recommended;
        } else {
          //this condition will be handles when subject will be changed and no objectives are selected for it
          newParams["objectiveLevelId"] = "";
        }
      }
    }
    this.setState({
      subjectGroupPair: update(subjectGroupPair, {
        [index]: {
          $set: { ...oldParams, ...newParams },
        },
      }),
    });

    const updateValueForKeys = ["subject"];
    if (isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled) {
      updateValueForKeys.push("objectiveLevelId");
    }
    //Send only when subject or objective field toggle
    if (_.includes(updateValueForKeys, key)) {
      setTimeout(() => {
        this.updateValueLocally();
      });
    }
  };

  //Converting subjectGroupPair into subject and subjectGroups and send them to parent
  updateValueLocally = () => {
    const {
      options,
      isObjectivePhasesEnabled,
      isObjectivePhaseRecommendationEnabled,
    } = this.props;
    const { subjectGroupPair } = this.state;
    const subjectGroups = _.get(options, "subjectGroups", []);
    const {
      value,
      nodes,
      subjectGroupValue,
      subjectGroupNodes,
      objectiveLevelValue,
    } = _.reduce(
      subjectGroupPair,
      (result, pair) => {
        //subject group will be given empty string for added tabs which are not yet selected
        const subjectGroup =
          _.find(
            subjectGroups,
            sg => _.findIndex(sg.subjects, sub => sub.id == pair.subject) >= 0
          ) || "";
        const subject = _.find(
          subjectGroup.subjects,
          sub => sub.id == pair.subject
        );
        if (isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled) {
          result.objectiveLevelValue = result.objectiveLevelValue || [];
          if (pair.objectiveLevelId) {
            const objectiveLevelIds = _.isArray(pair.objectiveLevelId)
              ? pair.objectiveLevelId
              : [pair.objectiveLevelId];
            result.objectiveLevelValue.push(...objectiveLevelIds);
          }
        }
        result.value.push(pair.subject);
        result.nodes.push({ node: { ...subject, subjectGroup } });
        if (!_.includes(result.subjectGroupValue, subjectGroup.id)) {
          result.subjectGroupValue.push(subjectGroup.id);
          result.subjectGroupNodes.push({ node: subjectGroup });
        }

        return result;
      },
      {
        value: [],
        nodes: [],
        subjectGroupValue: [],
        subjectGroupNodes: [],
        objectiveLevelValue: [],
      }
    );
    this.updateValue(value, {
      nodes,
      subjectGroupValue,
      subjectGroupNodes,
      ...(isObjectivePhasesEnabled || isObjectivePhaseRecommendationEnabled
        ? { objectiveLevelValue }
        : {}),
    });
  };

  //get the objectives for the selected subject
  getObjectiveLevelOptions = ({
    objectiveLevelNodes,
    subject,
    SubjectGroupList,
    courseDetails,
    subjectGroup,
    objectiveLevelId = [],
    selectedObjectiveLevelsWithValue,
    isInterDisciplinaryUnitPlan,
  }) => {
    const { isObjectivePhaseRecommendationEnabled } = this.props;
    const currentSubjectGroup = _.find(SubjectGroupList, { id: subjectGroup });
    const currentSubject = _.find(_.get(currentSubjectGroup, "subjects", []), {
      id: subject,
    });
    const currentGrade = _.get(courseDetails, "primaryGrade.id", "");
    const currentSubjectRecommendedPhase = _.find(
      _.get(currentSubject, "recommendedPhase", []),
      { gradeId: currentGrade }
    );
    let objectiveLevels = [];
    const recommendedObjective = [];
    // iterating through all the objective and find the objectives that are related to selected subject
    _.forEach(objectiveLevelNodes, objectiveLevelNode => {
      if (_.find(objectiveLevelNode.associatedParents, { id: subject })) {
        const recommendedObjectiveId = currentSubjectRecommendedPhase?.phaseId;

        if (
          currentSubjectRecommendedPhase &&
          recommendedObjectiveId == objectiveLevelNode.id
        ) {
          recommendedObjective.push({
            value: objectiveLevelNode.id,
            isDisabled:
              isObjectivePhaseRecommendationEnabled &&
              (_.includes(
                selectedObjectiveLevelsWithValue,
                objectiveLevelNode.id
              ) ||
                isInterDisciplinaryUnitPlan),
            label: (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "4px",
                }}
                size="xx-small"
              >
                {objectiveLevelNode.label}{" "}
                {_.isEqual(
                  currentSubjectRecommendedPhase?.phaseId,
                  objectiveLevelNode?.id
                ) &&
                  isObjectivePhaseRecommendationEnabled && (
                    <Tag size="xx-small" color="teal">
                      {t("unitPlan:recommended")}
                    </Tag>
                  )}
              </span>
            ),
            name: objectiveLevelNode.label,
            recommended: currentSubjectRecommendedPhase?.phaseId,
          });
          recommendedObjective.push({
            value: "",
            recommended: currentSubjectRecommendedPhase?.phaseId,
            label: "",
            isDivider: true,
          });
        } else {
          objectiveLevels.push({
            value: objectiveLevelNode.id,
            isDisabled:
              isObjectivePhaseRecommendationEnabled &&
              _.includes(
                selectedObjectiveLevelsWithValue,
                objectiveLevelNode.id
              ),
            label: (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "4px",
                }}
                size="xx-small"
              >
                {objectiveLevelNode.label}{" "}
                {_.isEqual(
                  currentSubjectRecommendedPhase?.phaseId,
                  objectiveLevelNode?.id
                ) &&
                  isObjectivePhaseRecommendationEnabled && (
                    <Tag size="xx-small" color="teal">
                      {t("unitPlan:recommended")}
                    </Tag>
                  )}
              </span>
            ),
            name: objectiveLevelNode.label,
            recommended: currentSubjectRecommendedPhase?.phaseId,
          });
        }
      }
    });
    objectiveLevels = _.concat(recommendedObjective, objectiveLevels);
    return objectiveLevels;
  };

  getSubjectGroupOptions = () => {
    const { options } = this.props;
    const subjectGroupOptions = _.get(options, "subjectGroups", []);

    return _.map(subjectGroupOptions, opt => {
      const iconKey = _.get(
        opt,
        "globalSubjectGroup.constants.iconKey",
        "COMMON"
      );
      const icon = _.get(
        _.find(ICON_SUBJECT_GROUP_MAPPING, { iconKey }),
        "icon",
        ""
      );

      return { label: opt.name, value: opt.id, icon, iconType: "COMPONENT" };
    });
  };

  //Remove those subjects which are already selected
  getSubjectOptions = ({ subjectGroup, subject }) => {
    const { options } = this.props;
    const { subjectGroupPair } = this.state;
    const subjectGroupOptions = _.get(options, "subjectGroups", []);
    let subjectOptions = _.get(
      _.find(subjectGroupOptions, { id: subjectGroup }),
      "subjects",
      []
    );
    subjectOptions = _.filter(subjectOptions, sg => {
      return !_.find(
        subjectGroupPair,
        pair => pair.subject == sg.id && pair.subject != subject
      );
    });

    return _.map(subjectOptions, opt => {
      return {
        label: opt.name,
        value: opt.id,
        icon: opt.icon,
        iconType: "URL",
        isArchived: _.get(opt, "isArchived", false),
      };
    });
  };

  updateRef = ({ ref, key, index }) => {
    if (!this.pairRefs[index]) {
      this.pairRefs[index] = {};
    }
    this.pairRefs = update(this.pairRefs, {
      [index]: { [key]: { $set: ref } },
    });
  };

  renderEdit = () => {
    const {
      subjectGroupPair,
      showEditModal,
      showObjectiveRemoveModal,
      removedObjectiveLevel,
      objectiveUpdateValue,
    } = this.state;
    const {
      t,
      options: {
        initSubject = {},
        isEditable = true,
        objectiveLevelNodes,
        selectedObjectiveLevelsWithValue,
        unitType,
        courseDetails,
        subjectGroups: SubjectGroupList,
      } = {},
      multi,
      value,
      options,
      parentType,
      isObjectivePhasesEnabled,
      isObjectivePhaseRecommendationEnabled,
    } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.subjectGroupPairs}>
          {_.map(subjectGroupPair, (pair, index) => {
            const { subjectGroup, subject, objectiveLevelId } = pair;
            const subjectGroupOptions = this.getSubjectGroupOptions({
              subjectGroup,
            });
            const subjectOptions = this.getSubjectOptions({
              subjectGroup,
              subject,
            });

            //For interdisciplinary units user can only edit the subjects from edit modal
            const isInterDisciplinaryUnitPlan =
              unitType == MYP_INTERDISCIPLINARY && parentType == "UNIT_PLAN";

            const objectiveLevelOptions = this.getObjectiveLevelOptions({
              objectiveLevelNodes,
              subject,
              SubjectGroupList,
              courseDetails,
              subjectGroup,
              objectiveLevelId,
              selectedObjectiveLevelsWithValue,
              isInterDisciplinaryUnitPlan,
            });
            //For interdisciplinary unit the 1 subject will always be the subject of course so it will be always disabled
            const isDisabled =
              (_.get(initSubject, "id", "") == pair.subject ||
                !isEditable ||
                index == 0) &&
              !_.isEmpty(value);

            const canBeDeleted = subjectGroupPair.length > 2;

            //get the objectives with selected objectives
            //handling old unit where multiple objective levels are selected
            const selectedObjectiveLevelIds = _.intersection(
              selectedObjectiveLevelsWithValue,
              _.map(
                this.getObjectiveLevelOptions({
                  objectiveLevelNodes,
                  subject,
                  SubjectGroupList,
                  courseDetails,
                  subjectGroup,
                }),
                objectivelevel => objectivelevel.value
              )
            );

            /*selectedObjectiveLevelsWithValue consist of array of all elements which are selected in the objectivesMYP section
            eg for interdisciplinary there are objective selected in Disciplinary_subjectname so the value of objectives parent 
            will be stored in this
            eg for subject specific unit there is a objective tab so the value of the selected objective's parent will be stored here
            */
            //also disable the objective levels for the subject with multiple objectives selected(old units)
            const isObjectiveLevelOptionDisabled = ACLStore.can(
              ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION
            )
              ? isInterDisciplinaryUnitPlan
              : _.includes(
                  options.selectedObjectiveLevelsWithValue,
                  _.isArray(objectiveLevelId)
                    ? objectiveLevelId[0]
                    : objectiveLevelId
                ) ||
                isInterDisciplinaryUnitPlan ||
                selectedObjectiveLevelIds.length > 1;

            const objectiveLevelLabel = _.get(
              _.find(objectiveLevelOptions, {
                value: _.isArray(objectiveLevelId)
                  ? objectiveLevelId[0]
                  : objectiveLevelId,
              }),
              "name",
              ""
            );

            const recommendedObjectiveLevel =
              objectiveLevelOptions &&
              _.find(objectiveLevelOptions, {
                value: objectiveLevelOptions[0]?.recommended,
              });

            return (
              <div className={classes.pairContainer} key={index}>
                {_.size(subjectGroupPair) > 1 && (
                  <div className={classes.titleContainer}>
                    <div className={classes.titleText}>
                      {t("unitPlan:unitType_subject_count", {
                        unitType: t("common:interdisciplinary"),
                        count: index + 1,
                      })}
                    </div>
                    {!isDisabled && canBeDeleted && (
                      <div
                        className={classes.removeContainer}
                        onClick={() => this.onDeleteClick({ index })}
                      >
                        <span> {t("common:remove")} </span>
                        <DeleteOutlined size="xxxx-small" variant="critical" />
                      </div>
                    )}
                  </div>
                )}

                <div className={classes.pair}>
                  <div className={classes.topContainer}>
                    <div className={classes.childPair}>
                      <FormSelectDropdown
                        value={subjectGroup}
                        updateInputField={value =>
                          this.updateOption({
                            key: "subjectGroup",
                            value,
                            index,
                          })
                        }
                        optionContainerStyle={styles.optionContainerStyle}
                        disabled={isDisabled}
                        label={t("unitPlan:subject_group")}
                        options={subjectGroupOptions}
                        shouldApplyDisabledClass={false}
                        placeholder={t("common:select_with_label", {
                          label: t("common:subject_group"),
                        })}
                        size="large"
                        customRef={ref =>
                          this.updateRef({ ref, index, key: "subjectGroup" })
                        }
                      />
                    </div>
                    <div className={classes.childPair}>
                      <FormSelectDropdown
                        value={subject}
                        updateInputField={value =>
                          this.updateOption({ key: "subject", value, index })
                        }
                        optionContainerStyle={styles.optionContainerStyle}
                        label={t("unitPlan:subject_select_label")}
                        disabled={isDisabled}
                        options={subjectOptions}
                        shouldApplyDisabledClass={false}
                        placeholder={t("common:select_with_label", {
                          label: t("unitPlan:subject_select_label"),
                        })}
                        size="large"
                        customRef={ref =>
                          this.updateRef({ ref, index, key: "subject" })
                        }
                      />
                    </div>
                  </div>
                  <div className={classes.childPair}>
                    {isObjectivePhasesEnabled ||
                    isObjectivePhaseRecommendationEnabled ? (
                      <FormSelectDropdown
                        isSelectAllEnabled={false}
                        value={objectiveLevelId}
                        disabled={
                          isObjectiveLevelOptionDisabled ||
                          _.isEmpty(objectiveLevelOptions)
                        }
                        updateInputField={value =>
                          this.updateObjectiveOption({
                            key: "objectiveLevelId",
                            value,
                            index,
                          })
                        }
                        label={t("unitPlan:myp_objective_year_phase")}
                        optionContainerStyle={styles.optionContainerStyle}
                        options={objectiveLevelOptions}
                        shouldApplyDisabledClass={false}
                        placeholder={t("unitPlan:select_year_phase")}
                        customRef={ref =>
                          this.updateRef({
                            ref,
                            index,
                            key: "objectiveLevelId",
                          })
                        }
                        multi={ACLStore.can(
                          ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION
                        )}
                        showCheckbox={ACLStore.can(
                          ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION
                        )}
                        size="large"
                      />
                    ) : null}
                  </div>
                  {isObjectivePhasesEnabled &&
                  !isObjectivePhaseRecommendationEnabled &&
                  !_.isEmpty(objectiveLevelId) ? (
                    <div className={classes.alertContainer}>
                      <Alert
                        type={"warning"}
                        message={t(
                          "unitPlan:myp_objective_unit_plan_create_warning_msg",
                          { label: objectiveLevelLabel }
                        )}
                      />
                    </div>
                  ) : null}
                  {isObjectivePhaseRecommendationEnabled &&
                  recommendedObjectiveLevel &&
                  !_.includes(
                    objectiveLevelId,
                    recommendedObjectiveLevel.value
                  ) &&
                  !_.isEmpty(objectiveLevelId) &&
                  options.courseDetails ? (
                    <div className={classes.alertContainer}>
                      <Alert
                        type={"warning"}
                        message={
                          <Trans i18nKey="unitPlan:myp_recommended_objective_unit_plan_create_warning_msg">
                            IB recommends
                            <strong>
                              {{
                                phase: recommendedObjectiveLevel?.name,
                              }}
                            </strong>
                            {{
                              grade: options?.courseDetails?.primaryGrade?.name,
                            }}
                            for students. Please ensure you are aware of the
                            selection made before you proceed.
                          </Trans>
                        }
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
        {multi && isEditable && (
          <div className={classes.addButtonContainer} onClick={this.onAddClick}>
            <div className={classes.addButtonSvgContainer}>
              <AddCircleFilled variant={"link"} size={"x-small"} />
            </div>

            <div className={classes.addAnotherButton}>
              {t("unitPlan:add_idu_subject")}
            </div>
          </div>
        )}
        {showEditModal && (
          <SubjectEditModal
            value={value}
            options={{ ...options, isEditable: true }}
            isAbsoluteCancelIcon={true}
            onCancelClick={this.onCancelModalEdit}
            onSaveClick={this.onSaveModalEdit}
          />
        )}
        {showObjectiveRemoveModal && (
          <Modal
            width="402px"
            height="fit-content"
            onClose={() =>
              this.setState({
                showObjectiveRemoveModal: false,
                objectiveUpdateValue: {},
                removedObjectiveLevel: {},
              })
            }
            dsVersion="2.0"
          >
            <Modal.Header
              isClosable
              title={t("unitPlan:remove_phase_from_unit")}
              dsVersion="2.0"
              hasSeparator
            ></Modal.Header>
            <Modal.Body isScrollable={false} dsVersion="2.0">
              <div className={classes.modalBody}>
                <div className={classes.modalSubTitle}>
                  <Trans
                    i18nKey={"unitPlan:objective_level_change_warning"}
                    label={removedObjectiveLevel.label}
                  >
                    You are about to remove
                    <strong>{{ label: removedObjectiveLevel.label }}</strong>
                    from the unit
                  </Trans>
                </div>
                <Alert
                  type={"warning"}
                  variant="inline"
                  showIcon={false}
                  dsVersion="2.0"
                  message={
                    <ul className={classes.listContainer}>
                      <li>{t("unitPlan:remove_phase_modal_warning_1")}</li>
                      <li>{t("unitPlan:remove_phase_modal_warning_2")}</li>
                    </ul>
                  }
                />
                <div>{t("unitPlan:change_grade_modal_confirmation_msg")}</div>
              </div>
            </Modal.Body>
            <Modal.Footer dsVersion="2.0" hasSeparator>
              <div className={classes.footer}>
                <Button
                  dsVersion="2.0"
                  onClick={() =>
                    this.setState({
                      showObjectiveRemoveModal: false,
                      objectiveUpdateValue: {},
                      removedObjectiveLevel: {},
                    })
                  }
                  variant="neutral"
                  type="outlined"
                >
                  {t("common:cancel")}
                </Button>
                <Button
                  dsVersion="2.0"
                  type="fill"
                  onClick={() => {
                    this.updateOption(objectiveUpdateValue);
                    this.setState({
                      showObjectiveRemoveModal: false,
                      objectiveUpdateValue: {},
                      removedObjectiveLevel: {},
                    });
                  }}
                  variant="progressive"
                >
                  {t("common:proceed")}
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    );
  };

  renderView = () => {
    const { customTextStyle } = this.props;
    const { subjectGroupPair } = this.state;
    const value = _.map(subjectGroupPair, pair => {
      const { subject, objectiveLevelId } = pair;
      const result = objectiveLevelId
        ? `${subject} - ${objectiveLevelId}`
        : subject;
      return result;
    });
    return (
      <Listview value={value} mode={"view"} customTextStyle={customTextStyle} />
    );
  };
}

const mapStateToProps = () => {
  const isObjectivePhasesEnabled = !ACLStore.can(
    "FeatureFlag:RemoveMYPObjectivesPhase"
  );
  const isObjectivePhaseRecommendationEnabled = ACLStore.can(
    ENABLE_MYP_PHASE_SELECTION_RECOMMENDATION
  );
  return { isObjectivePhasesEnabled, isObjectivePhaseRecommendationEnabled };
};

SubjectGroupSelect.propTypes = {
  ...UIBaseComponent.propTypes,
};

SubjectGroupSelect.defaultProps = {
  ...UIBaseComponent.defaultProps,
  multi: true,
  isAbsoluteCancelIcon: true,
};

export default compose(
  connect(mapStateToProps, null, null, { withRef: true }),
  I18nHOC({ resource: ["common", "unitPlan"] })
)(SubjectGroupSelect);
